import {useEffect, useState} from "react";
import {Button, Modal} from 'react-bootstrap';

type ConfirmComponentParams = {
    bodyNode: React.ReactNode;
    confirmLabel: string;
    closeLabel: string;
    onConfirm: () => void,
    onClose: () => void,
    onHide: () => void,
    show: boolean,
};

const ConfirmComponent = ({
                              bodyNode,
                              confirmLabel,
                              closeLabel,
                              onConfirm,
                              onClose,
                              onHide,
                              show,
                          }: ConfirmComponentParams) => {

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setShowModal(show)
    }, [show]);

    const handleConfirm = () => {
        setShowModal(false)
        onConfirm();
    }

    const handleClose = () => {
        setShowModal(false)
        onClose();
    }

    const handleHide = () => {
        setShowModal(false)
        onHide();
    }

    return (
        <>
            <Modal show={showModal} centered className="confirmModalContainer" onHide={() => handleHide()}>
                <Modal.Dialog>
                    <Modal.Header closeButton>

                    </Modal.Header>
                    <Modal.Body>
                        {bodyNode}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="outline-primary" className='p-2' onClick={() => handleClose()}>{confirmLabel}</Button>
                        <Button variant="primary" className='p-2' onClick={() => handleConfirm()}>{closeLabel}</Button>
                    </Modal.Footer>
                </Modal.Dialog>
            </Modal>
        </>
    );
};

export default ConfirmComponent;